import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';

interface Props {
  children?: ReactNode;
  FallbackComponent: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      // error: '',
      // errorInfo: '',
      hasError: false,
    };
  }

  static getDerivedStateFromError(error: Error, _errorInfo: ErrorInfo) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // error can ber push to API
    console.log({ error, errorInfo });
    this.setState({ hasError: true });
  }

  render() {
    const { children, FallbackComponent } = this.props;
    if (this.state.hasError) {
      return FallbackComponent;
    }

    return children;
  }
}
